export const SORTING_COLUMN = 'sortingColumn';
export const SORT_DIRECTION = 'sortDirection';

// used for translating forms on render
export const LANG = 'lang';

// used to pre-select values form creation
export const FORM_TYPE = 'formType';
export const TEMPLATE = 'template';
export const BUSINESS_UNIT = 'businessUnit';

// framework table reload
export const RELOAD = 'reload';

// framework table filters
export const FORM_QUERY = 'query';
export const BUSINESS_UNIT_IDS_FILTER = 'businessUnitIds';
export const FORM_TYPE_FILTER = 'formType';
export const PAGE_COUNT = 'count';
export const PAGE_OFFSET = 'offset';
export const SORT_KEY = 'sortKey';
export const SORT_ORDER = 'sortOrder';

// used to trigger popup form creation
export const CREATE_POPUP_FORM = 'createPopupForm';
export const FRAMEWORK_TABLE_PARAMS = [FORM_QUERY, FORM_TYPE_FILTER, FORM_TYPE_FILTER, PAGE_COUNT, PAGE_OFFSET, SORT_KEY, SORT_ORDER];
export const FRAMEWORK_TABLE_DEFAULT_PARAMS = {
  [PAGE_COUNT]: 25,
  [PAGE_OFFSET]: 0,
  [SORT_ORDER]: 'DESC',
  [SORT_KEY]: 'hs_updated_at'
};